// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedSettingConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import AuthorizationConstants from 'logic/data/Izenda.AuthorizationConstants';
import localizer from 'share/localization/Izenda.Localizer';

export default {
  get MENU() {
    return [
      {
        key: 'performance',
        icon: 'icon-gauge',
        title: localizer.getText('ADVANCED_SETTINGS_CONSTANTS_LABEL_MENU_PERFORMANCE'),
        forSystemAdmin: true
      },
      {
        key: 'security',
        icon: 'icon-lock',
        title: localizer.getText('ADVANCED_SETTINGS_CONSTANTS_LABEL_MENU_SECURITY'),
        forSystemAdmin: true
      },
      {
        key: 'category',
        icon: 'icon-list-bullet',
        title: localizer.getText('ADVANCED_SETTINGS_CONSTANTS_LABEL_MENU_CATEGORY'),
        permissionKeys: [AuthorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsCategory]
      },
      {
        key: 'others',
        icon: 'icon-resize-small-alt',
        title: localizer.getText('COMMON_LABEL_OTHERS'),
        permissionKeys: [AuthorizationConstants.PERMISSION_KEY.DataSetupAdvancedSettingsOthers]
      }
    ];
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.AdvancedSettingsConstants.js